import { Injectable, OnInit, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ApiEndpoints } from './../../../shared/services/api-endpoints.service';
import { CookieService } from 'ngx-cookie-service';
import { Lead } from '../../../shared/models/lead.model';
import { StorageService } from '../../../shared/services/auth/storage.service';
import { Observable, of } from 'rxjs';
import { Log, Level } from 'ng2-logger/client';
import { Subject } from 'rxjs';

const log = Log.create('profile-data.service.ts');

@Injectable()
/**
 * @author Malek Motan, 2018
 * */
export class LeadProfileData {
  private test: any;
  private leadId: string;
  private leadSource: string;
  private token = this.Cookie.get('squanchy');
  public leadProfile;
  private leadData = new Subject<any>();
  public leadUpdated = this.leadData.asObservable();
  public modifiedLead: any;

  public leadUpdateEmitter$: EventEmitter<Boolean>;

  constructor(
    private HttpService: HttpClient,
    private Cookie: CookieService,
    private URL: ActivatedRoute,
    private apiEndpoints: ApiEndpoints,
  ) {
    URL.params.subscribe(params => {
      this.leadId = params['id'];
      this.leadSource = params['source'];
    });

    this.leadUpdateEmitter$ = new EventEmitter();
  }

  /**
   *
   * @param lead the updated lead
   */
  updatedLeadData(lead) {
    this.modifiedLead = lead;
    this.leadData.next(lead);
  }

  /**
   * @description This method is used to update the edited lead info
   *
   * @param  {object} leadData
   *
   * @returns {object} http response
   */
  updateLeadProfileInfo(lead: Lead) {
    this.leadUpdateEmitter$.emit(true);
    /** Provide the model with the lead ID and the edited lead data */
    return this.apiEndpoints.post('editLeadProfile', lead.toApiJSON());
  }

  markLeaqdAsOld(id) {
    let readyObj = {
      leadId: id,
      leadData: {
        is_new: 0,
      },
    };
    return this.apiEndpoints.post('editLeadProfile', readyObj);
  }

  /**
   * @description This method is used to get the edited lead info
   *
   * @param  {integer} leadId
   * @param  {object} leadSource
   *
   * @returns {object} http response
   */

  getLeadProfileInfo(leadId, leadSource) {
    return this.apiEndpoints.get(
      'getLeadProfile',
      { source: leadSource },
      { id: leadId },
    );
  }
}
